var levelOfAWSUsage = {
	"Level of AWS usage": "ระดับการใช้งาน AWS",
	"Do not use AWS today": "ไม่ได้ใช้ AWS ในปัจจุบัน",
	"Evaluating/experimenting with AWS": "การประเมิน/การทดลองใช้งาน AWS",
	"Run dev/test workloads on AWS": "ใช้งานเวิร์กโหลด dev/ทดสอบใน AWS",
	"Run a production workload on AWS": "ใช้งานเวิร์กโหลดผลิตภัณฑ์เดียวใน AWS",
	"Run multiple production workloads on AWS": "ใช้งานเวิร์กโหลดหลายผลิตภัณฑ์ใน AWS"
};

export { levelOfAWSUsage as default };
